import React from 'react';

import InvertedCommas from '../assets/inverted-commas-svg.svg';

const TestimonialsCard = ({ testimonial }) => {
    return (
        <div className="testimonials_card">
            <img src={testimonial.url} alt="" className="testimonials_card-img" />
            <div className="testimonials_card-content">
                {/* <span className="testimonials_card-triangle" /> */}
                <img src={InvertedCommas} alt="" className="testimonials_card-commas" />
                <div className="testimonials_card-user">
                    <p className="testimonials_card-para">{testimonial.content}</p>
                    <h3 className="testimonials_card-name">{testimonial.name}</h3>
                </div>
            </div>
        </div>
    );
}

export default TestimonialsCard;
